import Vue from 'vue'
import Router from 'vue-router'
import App from '../App.vue'

// index
const index = () => import('@/pages/index/index')
//首页
const home = () => import('@/pages/index/home/index')
const article = () => import('@/pages/index/article/index')
const post = () => import('@/pages/index/post/index')
const promotion = () => import('@/pages/index/promotion/index')
const friend = () => import('@/pages/index/friend/index')
const find = () => import('@/pages/index/find/index')
const livaiaFM = () => import('@/pages/index/livaiaFM/index')
//我的主页
const pagehome = () => import('@/pages/homePage/index')
//我的主页
const myhome = () => import('@/pages/homePage/home/home')
const likeNotice = () => import('@/pages/homePage/notice/likeNotice/likeNotice')
const commentNotice = () => import('@/pages/homePage/notice/commentNotice/commentNotice')
const friendUpdates = () => import('@/pages/homePage/notice/friendUpdates/friendUpdates')
const systemNotice = () => import('@/pages/homePage/notice/systemNotice/systemNotice')
const articleManage = () => import('@/pages/homePage/manage/articleManage/articleManage')
const videoManage = () => import('@/pages/homePage/manage/videoManage/videoManage')
const postManage = () => import('@/pages/homePage/manage/postManage/postManage')

const collect = () => import('@/pages/homePage/collect/collect')
const history = () => import('@/pages/homePage/history/history')
const chat = () => import('@/pages/homePage/chat/chat')
const comment = () => import('@/pages/homePage/comment/comment')
const like = () => import('@/pages/homePage/like/like')
const help = () => import('@/pages/homePage/help/help')

Vue.use(Router)
export default new Router({
  // scrollBehavior (to, from, savedPosition) {
  //   if (to.name === 'index' || to.name === 'community' || to.name === 'video' || to.name === 'member') {
  //     let scroll = 0
  //     if (document.documentElement && document.documentElement.scrollTop) {
  //       scroll = document.documentElement.scrollTop
  //     } else {
  //       scroll = document.body.scrollTop
  //     }
  //     if (from.name === 'index' || from.name === 'community' || from.name === 'video' || from.name === 'member') {
  //       sessionStorage.setItem(from.name, scroll)
  //     }
  //     if (sessionStorage.getItem(to.name)) {
  //       return {x: 0, y: parseInt(sessionStorage.getItem(to.name))}
  //     } else {
  //       return {x: 0, y: 0}
  //     }
  //   }
  //   return {x: 0, y: 0}
  // },
  // mode: 'history',
  routes: [{
    path: '',
    redirect: '/index',
    component: App,
    children: [
      // index
      {
        name: '',
        path: '/index',
        component: index,
        children: [
          {
            name: 'index',
            path: '/index',
            component: home,
          },
          {
            name: 'article',
            path: '/article',
            component: article,
          },
          {
            name: 'post',
            path: '/post',
            component: post,
          },
          {
            name: 'promotion',
            path: '/promotion',
            component: promotion,
          },
          {
            name: 'friend',
            path: '/friend',
            component: friend,
          },
          {
            name: 'find',
            path: '/find',
            component: find,
          },
          {
            name: 'livaiaFM',
            path: '/livaiaFM',
            component: livaiaFM,
          }
        ]
      },
      // 
      {
        name: '',
        path: '/pagehome',
        component: pagehome,
        children: [
          {
            name: 'home',
            path: '/pagehome',
            component: myhome,
          },
          {
            name: 'likeNotice',
            path: '/likeNotice',
            component: likeNotice,
          },
          {
            name: 'commentNotice',
            path: '/commentNotice',
            component: commentNotice,
          },
          {
            name: 'friendUpdates',
            path: '/friendUpdates',
            component: friendUpdates,
          },
          {
            name: 'systemNotice',
            path: '/systemNotice',
            component: systemNotice,
          },
          {
            name: 'articleManage',
            path: '/articleManage',
            component: articleManage,
          },
          {
            name: 'videoManage',
            path: '/videoManage',
            component: videoManage,
          },
          {
            name: 'postManage',
            path: '/postManage',
            component: postManage,
          },
          {
            name: 'collect',
            path: '/collect',
            component: collect,
          },
          {
            name: 'history',
            path: '/history',
            component: history,
          },
          {
            name: 'chat',
            path: '/chat',
            component: chat,
          },
          {
            name: 'comment',
            path: '/comment',
            component: comment,
          },
          {
            name: 'like',
            path: '/like',
            component: like,
          },
          {
            name: 'help',
            path: '/help',
            component: help,
          }
        ]
      }
    ]
  }]
})
